module.exports = "/_next/static/images/bd03e31d173512dac0e394d74a6653e6-improving.svg.webp";